import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import { ScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';
import { StickyFooter } from 'foundations-components/transitional/components/StickyFooter';
import _isNil from 'hs-lodash/isNil';
import _omitBy from 'hs-lodash/omitBy';
import { useContext, useEffect } from 'react';
import { ACTIONS, SCREENS } from '../../constants/Tracking';
import { NON_HOST_EXPERIENCE_REFRESH_TIMEOUT } from '../../constants/timeouts';
import { AppContext } from '../../contexts/app/context';
import { CommentsPropsContext } from '../../contexts/comments/PropsContext';
import { defaultCommentsProps } from '../../contexts/comments/constants';
import { CommentsContext, CommentsContextProvider } from '../../contexts/comments/context';
import useInterval from '../../hooks/useInterval';
import { getCtaUrl, getUserIdsFromComment } from '../../utils/comments';
import CommentList from './CommentList';
import CommentRichTextEditor from './CommentRichTextEditor';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function Comments() {
  const {
    portalId,
    isStickyFooterHidden,
    callObjectId,
    usageTracker
  } = useContext(CommentsPropsContext);
  const {
    isLoading,
    comments,
    commentsActions
  } = useContext(CommentsContext);
  const {
    appName
  } = useContext(AppContext);
  const onSaveComment = commentId => ({
    newComment
  }) => {
    usageTracker.trackUsage(Object.assign({
      screen: SCREENS.comments,
      isNew: !commentId
    }, ACTIONS.comments.save));
    const ctaUrl = getCtaUrl({
      portalId,
      callObjectId
    });
    if (commentId) {
      commentsActions.updateComment({
        commentId,
        message: newComment,
        atMentionsOwnerIds: getUserIdsFromComment(newComment),
        ctaUrl
      });
    } else {
      commentsActions.createComment({
        callObjectId,
        message: newComment,
        atMentionsOwnerIds: getUserIdsFromComment(newComment),
        ctaUrl
      });
    }
  };
  const onDeleteComment = commentToDelete => {
    usageTracker.trackInteraction(Object.assign({
      screen: SCREENS.comments
    }, ACTIONS.comments.delete));
    commentsActions.deleteComment(commentToDelete.commentId);
  };
  useInterval(setSkipRefresh => commentsActions.getComments({
    callObjectId,
    isLoading: false,
    isPostponedAction: true,
    setSkipRefresh,
    storeComments: comments
  }), NON_HOST_EXPERIENCE_REFRESH_TIMEOUT, {
    cancelOnUnmount: true
  });
  useEffect(() => {
    usageTracker.trackPageView(SCREENS.comments);
  }, [usageTracker]);
  useEffect(() => {
    if (callObjectId) {
      commentsActions.getComments({
        callObjectId,
        isLoading: true,
        storeComments: comments
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callObjectId, commentsActions]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(View, {
      "data-test-id": `${appName}-comments-page`,
      paddingBlock: "500",
      paddingInline: "100",
      as: "div",
      children: [isLoading ? /*#__PURE__*/_jsx(LoadingOverlay, {
        contextual: true
      }) : null, comments.length ? /*#__PURE__*/_jsx(ScrollContainer, {
        children: /*#__PURE__*/_jsx(View, {
          padding: "200",
          as: "div",
          children: /*#__PURE__*/_jsx(CommentList, {
            comments: comments,
            onSaveComment: onSaveComment,
            onDeleteComment: onDeleteComment
          })
        })
      }) : null, isStickyFooterHidden ? null : /*#__PURE__*/_jsx(StickyFooter, {
        animateOnMount: true,
        "data-test-id": `${appName}-comments-editor`,
        children: /*#__PURE__*/_jsx(CommentRichTextEditor, {
          onSave: onSaveComment()
        })
      })]
    })
  });
}
const WrappedComments = props => {
  const definedProps = _omitBy(props, _isNil);
  return /*#__PURE__*/_jsx(CommentsPropsContext.Provider, {
    value: Object.assign({}, defaultCommentsProps, definedProps),
    children: /*#__PURE__*/_jsx(CommentsContextProvider, {
      children: /*#__PURE__*/_jsx(Comments, {})
    })
  });
};
export default WrappedComments;